<template>
  <div class="callout" :class="backgroundVariant">
    <div class="icon-wrapper" :class="spaciousIcon">
      <img v-if="iconPath" :src="require(`@/assets/${iconPath}`)">
      <div v-if="iconProps" class="icon-cover" :class="iconBackgroundVariant">
        <icon v-bind="iconProps" />
      </div>
    </div>
    <div class="text-wrapper">
      <div class="title" v-if="title">{{ title }}</div>
      <div class="text">
        <slot name="text"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from './Icon.vue';

export default {
  name: 'Callout',
  components: { Icon },
  props: {
    spaciousIcon: { type: Boolean, default: true },
    iconPath: { type: String, required: false },
    iconProps: { type: Object, required: false },
    iconBackgroundVariant: { type: String, required: false, default: 'info' },
    title: { type: String, required: false },
    backgroundVariant: { type: String, required: false, default: 'info' },
  },
};
</script>

<style scoped lang="scss">
@import "../scss/riseup-colors";

.callout {
  display: flex;
  flex-direction: row;
  border-radius: 8px;
  padding: 16px 10px;

  .icon-wrapper {
    display: flex;
    align-items: flex-start;
    margin-left: 10px;

    &.spaciousIcon {
      width: 24%;
    }
    &:not(.spaciousIcon) {
      max-width: 24%;
    }

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  .text-wrapper {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    line-height: 20px;

    .title {
      font-weight: bold;
    }
  }

  @each $variant, $color in $variant-to-color {
    &.#{$variant} {
      background-color: $color;
    }
  }

  .icon-cover {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    @each $variant, $color in $variant-to-color {
      &.#{$variant} {
        background-color: $color;
      }
    }
  }
}

</style>
